import React from 'react';
import { useEffect, useState } from 'react';
import Swp from '../../../lib/component/swp/swp';
import Loading from '../../../lib/component/loading1/loading';
import KeyWord from './keyWord1/keyWord';
import Card1 from './card1/card';

import publishApi from '../js/publishApi';
import { Section } from '../js/interface';
import statisticsApi from '../../../lib/statisticsApi';

export default () => {
  const [info, setInfo] = useState<Section[]>([]);
  const strSwpArr = ['subjectDetails', 'subjectDetails', 'subjectDetails', 'subjectDetails'];
  useEffect(() => {
    publishApi.getHomeApi(
      (res: any) => {
        setInfo([...res.boutique_sections]);
      },
      () => {}
    );
    statisticsApi.statisticsApi(3);
  }, []);

  function swpRender() {
    if (info.length) {
      return <Swp {...{ bdArr: info[0].boutique_data, strSwpArr: strSwpArr, tip: 'publish' }}></Swp>;
    }
  }

  function cardRender() {
    if (info.length) {
      return info.map((item, index) => {
        if (index > 0 && index < info.length - 1 && index % 2 === 0) {
          return <Card1 {...{ title: item.category?.name, bookArr: item.boutique_data, button: `全部${item.category?.name}`, fn: null }} key={index}></Card1>;
        }
      });
    } else {
      return <Loading></Loading>;
    }
  }

  return (
    <>
      {swpRender()}
      {info.length > 0 && <KeyWord {...{ keyWords: ['免费', '推荐', '专题', '包月'] }}></KeyWord>}
      {cardRender()}
      <div style={{ height: '50px' }}></div>
    </>
  );
};
